import React from "react";

export const FeaturesColorCorrection = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={56}
            height={57}
            viewBox="0 0 56 57"
            fill="none"
            {...props}
        >
            <path
                d="M19.991 37.35c3.018-.115 4.179-.691 4.179-3.572V12.922c0-.691-.233-.922-1.393-.922-3.83 0-6.268 2.305-6.965 5.992H15l.232-7.605h25.536L41 17.992h-.813C39.492 14.305 37.17 12 33.224 12c-1.16 0-1.393.116-1.393.922v20.971c0 2.881 1.161 3.457 4.179 3.572v.922H19.99V37.35z"
                fill="#32393E"
            />
            <path d="M46 42.387H10v4h36v-4z" fill="#FE9235"/>
        </svg>
    )
}
